import { useEffect, useContext, useState } from "react";
import { LoginContext } from "../../contexts/LoginContext";
import QualityCertificateRequestsAPI from "../../services/QualityCertificateRequestsAPI";
import { AppContext } from "../../contexts/AppContext";

import { decodeFile, decodeFileView } from "../../utils/MiscellaneousUtils";
import { decodeFileXLSX } from '../../utils/MiscellaneousUtils';
import { currentDateForFile, YMD_FORMAT, firstDayMonth } from '../../utils/DateUtils';
import moment from 'moment';

const useQualityCertificateRequestsPresenter = (tableRef) => {
  const { idSupplier, isSupplier } = useContext(LoginContext);
  const { showError, showSucess, showWarning } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [rowsToShow, setRowsToShow] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [oldSearchRequest, setOldSearchRequest] = useState({});
  const [openUploadCertificate, setOpenUploadCertificate] = useState(false);

  const [showNotCertificateRequired, setShowNotCertificateRequired] = useState(false);
  const [showCertificateRequired, setShowCertificateRequired] = useState(true);
  const [purchaseOrderCode, setPurchaseOrderCode] = useState("");
  const [selectedSupplier, setSelectedSupplier] = useState(null);

  const [loadingExport, setLoadingExport] = useState(false);

  const [openUpload, setOpenUpload] = useState(false);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);

  const [state, setState] = useState('Pendiente');
  const [openActivity, setOpenActivity] = useState(false)

  useEffect(() => {
    //isSupplier && search();
    if (!isSupplier) {
      setShowCertificateRequired(true);
      setShowNotCertificateRequired(false);
    }
    search();
  }, []);

  const subFilterRows = (rows) => {
    if (showCertificateRequired && showNotCertificateRequired) {
      return rows;
    } else if (showCertificateRequired) {
      return rows.filter((r) => r.statusDescription == "Pendiente");
    } else {
      return rows.filter((r) => r.statusDescription != "Pendiente");
    }
  };

useEffect(() => {
  setRowsToShow(subFilterRows(rows));

}, [rows]);

useEffect(() => {
  if(showNotCertificateRequired || showCertificateRequired){
    !firstLoad && search();
  }

},[showNotCertificateRequired, showCertificateRequired])

  const cleanFilters = () => {
    setPurchaseOrderCode("");
    setSelectedSupplier(null);
    setDateFrom(null);
    setDateTo(null);
    setShowNotCertificateRequired(false);
    setShowCertificateRequired(true);
  };

  const search = (reload) => {

    let status;
    if(showCertificateRequired && showNotCertificateRequired){
      status = '';
    }
    else if(showCertificateRequired && !showNotCertificateRequired){
      status = 'Pendiente'
    }
    else {
      status = 'Gestionado'
      
    }

    const request = reload
      ? oldSearchRequest
      : {
          SupplierId: isSupplier
            ? idSupplier
            : selectedSupplier
            ? selectedSupplier.cuit
            : "",
          PurchaseOrderCode: purchaseOrderCode,
          StatusDescription: status,
          startDate: dateFrom ? dateFrom.format(YMD_FORMAT) : undefined,
          endDate: dateTo ? dateTo.format(YMD_FORMAT) : undefined,
        };

    setOldSearchRequest(request);

    firstLoad && setFirstLoad(false);
    setLoading(true);
    setSelectedRows([]);

    QualityCertificateRequestsAPI.getDataGrid(request)
      .then((res) => setRows(res.data))
      .catch((error) => showError("Error al obtener los registros"))
      .finally(() => setLoading(false));
  };

  const handleExport = ids => {
    setLoadingExport(true);
    
    const request = ids ? ids : rows.map(r => r.id);

    QualityCertificateRequestsAPI.exportToExcel(request)
      .then(res => decodeFileXLSX(res, `Certificados_${currentDateForFile()}.xlsx`))
      .catch(error => showError('No se pudo descargar el archivo solicitado'))
      .finally(() => setLoadingExport(false));

  };

  const validateAndSearch = () => validateFilters() && search();

  const validateFilters = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;


    if ((errors[i++] = dateFrom && !dateTo)) errorMessages.push('Debe completar el rango de fechas o quitar la Fecha desde');
      if ((errors[i++] = !dateFrom && dateTo)) errorMessages.push('Debe completar el rango de fechas o quitar la Fecha hasta');

    if(showNotCertificateRequired && dateFrom && dateTo){
      let dateFromValues = dateFrom.format(YMD_FORMAT).split('-');
      let dateToValues = dateTo.format(YMD_FORMAT).split('-');
      dateFromValues[1] = (Number.parseInt(dateFromValues[1]) + 2);
    
      if((errors[i++] = dateFromValues[1] < Number.parseInt(dateToValues[1]))) errorMessages.push('Al estar activado Gestionado el rango entre fechas no puede ser mayor a 2 meses.');
      if(dateFromValues[1] == dateToValues[1]){
        if((errors[i++] = Number.parseInt(dateFromValues[2]) < Number.parseInt(dateToValues[2]))) errorMessages.push('Al estar activado Gestionado el rango entre fechas no puede ser mayor a 2 meses.');
      }
    }
    else if((errors[i++] = showNotCertificateRequired && !dateFrom && !dateTo)){
      errorMessages.push('Al estar activado Gestionado el rango entre fechas no puede ser mayor a 2 meses.')
    }
    

    const hasErrors = errors.some((e) => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const reloadGrid = () => search(true);

  const handleDownloadFile = (id, fileName) => {

    return QualityCertificateRequestsAPI.getFile(id, fileName)
      .then(

        (res) => {
          res.map(r => decodeFile(r, r.name))
          }
      )
      .catch((error) => {
        const errorMsg = "Error al obtener los archivos adjuntos";
        showError(errorMsg, error);
      });
  };

  return {

    selectedSupplier,
    setSelectedSupplier,
    purchaseOrderCode,
    setPurchaseOrderCode,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    validateAndSearch,
    cleanFilters,
    rows: rowsToShow,
    firstLoad,
    loading,

    gridFunctions: {
      disableSelectAll: showNotCertificateRequired,
      reloadGrid,
      selectedRows,
      setSelectedRows,
      open,
      setOpen,
      openUploadCertificate,
      setOpenUploadCertificate,
      openActivity,
      setOpenActivity,
      cuit: oldSearchRequest.cuit,

      handleDownloadFile,
      openUpload,
      setOpenUpload,

      gridActions: {
        showCertificateRequired,
        setShowCertificateRequired,
        showNotCertificateRequired,
        setShowNotCertificateRequired,
        
        state,
        setState,
        dateFrom,
        setDateFrom,
        dateTo,
        setDateTo,
        loadingExport,
        handleExport,
      },
    },
  };
};

export default useQualityCertificateRequestsPresenter;
